const toggleWishlistProduct  = productCode => {
  if (window.reece && window.reece.wishlist) {
    window.reece.wishlist.updateProductInWishlist(productCode);
  }
};

export default toggleWishlistProduct;